// src/components/Contact.jsx
export default function Contact() {
  return (
    <section id="contact" className="section">
      <div className="section-header">
        <h2>contact</h2>
        <span className="section-line"></span>
      </div>
      <div className="contact-content">
        <p>
          <a href="mailto:liunathalie@hotmail.fr" className="contact-link">
            liunathalie@hotmail.fr
          </a>
        </p>
        <p>
          <a href="https://linkedin.com/in/nathalieliu" target="_blank" rel="noreferrer" className="contact-link">
            linkedin.com/in/nathalieliu
          </a>
        </p>
        <p>
          <a href="https://github.com/nathaliu" target="_blank" rel="noreferrer" className="contact-link">
            github.com/nathaliu
          </a>
        </p>
      </div>
    </section>
  );
}